module.exports = __webpack_public_path__ + "media/images/new-ui-images/avatar-2-5cc29b51dc396c668835303a9d055833.png";